export default "__VITE_ASSET__DAUG2yt1__"